import { render, staticRenderFns } from "./tips-pop.vue?vue&type=template&id=de9a9dd2&scoped=true&"
import script from "./tips-pop.vue?vue&type=script&lang=js&"
export * from "./tips-pop.vue?vue&type=script&lang=js&"
import style0 from "./tips-pop.vue?vue&type=style&index=0&id=de9a9dd2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9a9dd2",
  null
  
)

export default component.exports